var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { getTypographyStyles, TYPOGRAPHY_TYPE } from '../../../theme/typography';
import { useTheme } from '../../../theme';
import { multiplyRemSize } from '../../../utils/misc';
export var PARAGRAPH_SIZE;
(function (PARAGRAPH_SIZE) {
    PARAGRAPH_SIZE["SM"] = "sm";
    PARAGRAPH_SIZE["MD"] = "md";
    PARAGRAPH_SIZE["LG"] = "lg";
})(PARAGRAPH_SIZE || (PARAGRAPH_SIZE = {}));
const SIZE_TYPOGRAPHY_MAP = {
    [PARAGRAPH_SIZE.SM]: TYPOGRAPHY_TYPE.PARAGRAPH_SMALL,
    [PARAGRAPH_SIZE.MD]: TYPOGRAPHY_TYPE.PARAGRAPH_MEDIUM,
    [PARAGRAPH_SIZE.LG]: TYPOGRAPHY_TYPE.PARAGRAPH_LARGE,
};
export const Paragraph = (_a) => {
    var _b, _c;
    var { size, typography: typographyParam, sx, clampLines } = _a, rest = __rest(_a, ["size", "typography", "sx", "clampLines"]);
    const theme = useTheme();
    const typography = typographyParam || SIZE_TYPOGRAPHY_MAP[size || PARAGRAPH_SIZE.MD];
    const typographyStyles = getTypographyStyles(typography);
    const marginHeightMultiple = (((_b = theme.lineHeights) === null || _b === void 0 ? void 0 : _b[typographyStyles.lineHeight]) || 1.625) * 0.7;
    const fontSize = ((_c = theme.fontSizes) === null || _c === void 0 ? void 0 : _c[typographyStyles.fontSize]) || '1rem';
    const topMargin = multiplyRemSize({
        size: fontSize,
        multiple: marginHeightMultiple,
    });
    return (_jsx("p", Object.assign({ sx: Object.assign(Object.assign(Object.assign({}, getTypographyStyles(typography)), { display: clampLines ? '-webkit-box' : undefined, WebkitLineClamp: clampLines ? String(clampLines) : undefined, WebkitBoxOrient: 'vertical', overflow: clampLines ? 'hidden' : undefined, mt: topMargin }), sx) }, rest)));
};
